import React from 'react'
import RadioInput from '../Inputs/RadioInput.js'
import { QUESTIONS } from '../../questions.js'




export default function FormPage2(props) {


    // Three questions per page; one on phones (IMP-083)
    const questionsToShow = QUESTIONS.slice(props.firstQuestion, props.firstQuestion + props.questionCount);


    const questionsMapped = questionsToShow.map((perQuestion, index) => {
        return (
            <RadioInput
                key={perQuestion.num}
                label={perQuestion.num}
                name={perQuestion.num}
                formData={props.formData}
                onChange={props.handleChange}
                optiona={perQuestion.optiona}
                optionb={perQuestion.optionb}
                questionNum={props.firstQuestion + index  /*This is used in the component to know which part of the array we're in */}
            />
        )
    })

    return (
        <div className="Form">
            <div className="Form--inputs-container">
                <p className="Form--instructions">Choose the statement that best describes you.</p>
                <div className="Form--questions-container">
                    {questionsMapped}
                </div>
            </div>


        </div>
    )
}